import { Toaster } from "./../customplugins/toaster.js";
import { Loader } from "./../customplugins/loader.js";
import { AutoCompleteSelect } from "../customplugins/autocomplete-select.js";
let stateAC: AutoCompleteSelect | null = null;
let cityAC: AutoCompleteSelect | null = null;
export interface StoreSearchRequest {
    pincode?: string;
    stateId?: number;
    cityId?: number;
    pageSize?: number;
    page?: number;
}

interface State {
    stateid: number;
    statename: string;
}

interface City {
    cityid: number;
    cityname: string;
}

export interface StoreLocation {
    scmId: number;
    scmUuid: string;
    scmCode: string;
    name: string;
    mobile?: string | null;
    email?: string | null;
    address: string;
    cityId: number;
    cityName: string;
    stateId: number;
    stateName: string;
    pincode: number;
}

export interface StoreLocatorResponse {
    items: StoreLocation[];
    total: number;
}

((): void => {

    //const pinForm = document.getElementById("pinForm") as HTMLFormElement;
    //const pinInput = document.getElementById("pin") as HTMLInputElement;
    //const pinBox = document.getElementById("pinBox") as HTMLElement;

    //const stateSelect = document.getElementById("state") as HTMLSelectElement;
    //const citySelect = document.getElementById("city") as HTMLSelectElement;

    //const grid = document.getElementById("grid") as HTMLElement;
    //const moreBtn = document.getElementById("more") as HTMLButtonElement;
   
    const pinForm = document.getElementById("pinForm") as HTMLFormElement | null;
    const pinInput = document.getElementById("pin") as HTMLInputElement | null;
    const pinBox = document.getElementById("pinBox") as HTMLElement | null;

    const stateSelect = document.getElementById("state") as HTMLSelectElement | null;
    const citySelect = document.getElementById("city") as HTMLSelectElement | null;

    const grid = document.getElementById("grid") as HTMLElement | null;
    const moreBtn = document.getElementById("more") as HTMLButtonElement | null;
    if (
        !pinForm ||
        !pinInput ||
        !pinBox ||
        !stateSelect ||
        !citySelect ||
        !grid ||
        !moreBtn
    ) {
        console.error("Store locator elements not found.");
        return;
    }
    let page = 1;
    let shown = 0;
    let lastQuery: StoreSearchRequest | null = null;

    function escapeHtml(value: unknown): string {
        return String(value ?? "")
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }
    //function resetCity(): void {

    //    citySelect.innerHTML =
    //        '<option value="">Select City</option>';

    //    citySelect.disabled = true;

    //    cityAC?.refresh();
    //}
    function resetCity(): void {

        citySelect.innerHTML =
            '<option value="">Select City</option>';

        citySelect.disabled = true;

        if (cityAC) {
            cityAC.refresh();
        }
    }
    async function loadStates(): Promise<void> {
       
        stateSelect.innerHTML =
            '<option value="">Select State</option>';

        try {

            const response = await fetch("/GetStates");

            if (!response.ok) {
                throw new Error("Failed to load states");
            }

            const states: State[] = await response.json();

            states.forEach(state => {

                const option = document.createElement("option");

                option.value = state.stateid.toString();
                option.textContent = state.statename;

                stateSelect.appendChild(option);
            });
            if (!stateAC) {
                stateAC = new AutoCompleteSelect("#state");
            } else {
                stateAC.refresh();
            }
        }
        //catch (error) {

        //    console.error(error);

        //    stateSelect.innerHTML =
        //        '<option value="">Unable to load states</option>';
        //    stateAC?.refresh();
        //}
        catch (error) {

            console.error(error);

            stateSelect.innerHTML =
                '<option value="">Unable to load states</option>';

            if (stateAC) {
                stateAC.refresh();
            }
        }
    }

    async function loadCities(stateId: number): Promise<void> {
        resetCity();
        citySelect.innerHTML =
            '<option value="">Select City</option>';

        citySelect.disabled = true;

        try {

            const response = await fetch(
                `/GetCitiesByStateID?stateid=${stateId}&pagenumber=1&rowscountperpage=50000`
            );

            if (!response.ok) {
                throw new Error("Failed to load cities");
            }

            const cities: City[] = await response.json();

            cities.forEach(city => {

                const option = document.createElement("option");

                option.value = city.cityid.toString();
                option.textContent = city.cityname;

                citySelect.appendChild(option);
            });
           
            citySelect.disabled = cities.length === 0;
            if (!cityAC) {
                cityAC = new AutoCompleteSelect("#city");
            } else {
                cityAC.refresh();
            }
        }
        //catch (error) {

        //    console.error(error);

        //    citySelect.innerHTML =
        //        '<option value="">Unable to load cities</option>';
        //    cityAC?.refresh();
        //}
        catch (error) {

            console.error(error);

            citySelect.innerHTML =
                '<option value="">Unable to load cities</option>';

            if (cityAC) {
                cityAC.refresh();
            }
        }
    }

    function renderStore(store: StoreLocation): string {

        const mapUrl =
            "https://www.google.com/maps/search/?api=1&query=" +
            encodeURIComponent(
                `${store.name}, ${store.address}, ${store.cityName} ${store.pincode}`
            );

        return `
            <article class="card">

                <div>
                    <h3>${escapeHtml(store.name)}</h3>
                    <div class="code">
                        ${escapeHtml(store.scmCode)}
                    </div>
                </div>

                <p class="addr">
                    ${escapeHtml(store.address)}
                </p>

                <p class="loc">
                    ${escapeHtml(store.cityName)},
                    ${escapeHtml(store.stateName)}
                    - ${store.pincode}
                </p>

                <div class="acts">

                    ${store.mobile
                ? `tel:${store.mobile}
                               Call ${escapeHtml(store.mobile)}
                           </a>`
                : ""}

                    ${mapUrl}
                        Get Directions
                    </a>

                    ${store.email
                ? `${store.email}
                               Email
                           </a>`
                : ""}

                </div>

            </article>
        `;
    }

    async function searchStores(
        request: StoreSearchRequest,
        append = false
    ): Promise<void> {

        if (!append) {

            page = 1;
            shown = 0;
            lastQuery = request;

            grid.innerHTML = `
                <div class="sk"></div>
                <div class="sk"></div>
                <div class="sk"></div>
            `;

            /*meta.textContent = "";*/
        }

        moreBtn.hidden = true;

        try {

            const params = new URLSearchParams();

            if (lastQuery && lastQuery.pincode) {
                params.append("pincode", lastQuery.pincode);
            }

            if (lastQuery && lastQuery.stateId) {
                params.append(
                    "stateId",
                    lastQuery.stateId.toString()
                );
            }

            if (lastQuery && lastQuery.cityId) {
                params.append(
                    "cityId",
                    lastQuery.cityId.toString()
                );
            }

            params.append("page", page.toString());
            Loader.show();
            const response = await fetch(
                `/Search?${params.toString()}`,
                {
                    method: "POST"
                }
            )
                .then(res => res.text())
                .then((response: any) => {
                    Loader.hide();
                    var data = document.getElementById("grid") as HTMLElement;
                    if (data) {
                        data.innerHTML = "";
                        data.innerHTML = response;
                        data.style.display = "block"
                    }
                });

            //if (!response.ok) {
            //    throw new Error("Failed to load stores");
            //}

            //const data: StoreLocatorResponse =
            //    await response.json();

            //if (!append) {
            //    grid.innerHTML = "";
            //}

            //if (!data.items?.length) {

            //    grid.innerHTML = `
            //        <div class="state">
            //            <h3>No stores found</h3>
            //            <p>
            //                Check the PIN code or select a different city/state.
            //            </p>
            //        </div>
            //    `;

            //    return;
            //}

            //grid.insertAdjacentHTML(
            //    "beforeend",
            //    data.items.map(renderStore).join("")
            //);

            //shown += data.items.length;

            //meta.textContent =
            //    `${data.total} store${data.total > 1 ? "s" : ""} found`;

            //moreBtn.hidden = shown >= data.total;
        }
        catch (error) {

            console.error(error);

            grid.innerHTML = `
                <div class="state err">
                    <h3>Couldn't load stores</h3>
                </div>
            `;
        }
    }

    pinInput.addEventListener("input", () => {

        pinInput.value =
            pinInput.value.replace(/\D/g, "");

        pinBox.classList.toggle(
            "ready",
            pinInput.value.length === 6
        );
    });

    //pinForm.addEventListener(
    //    "submit",
    //    async (e: SubmitEvent) => {

    //        e.preventDefault();

    //        const pin = pinInput.value;

    //        if (pin.length !== 6) {

    //            //meta.textContent =
    //            //    "Enter a valid 6-digit PIN code.";

    //            pinInput.focus();

    //            return;
    //        }

    //        stateSelect.value = "";
    //        stateAC?.refresh();
    //        citySelect.value = "";
    //        citySelect.disabled = true;
    //        resetCity();

    //        await searchStores({
    //            pincode: pin
    //        });
    //    }
    //);
    pinForm.addEventListener(
        "submit",
        async function (e: Event): Promise<void> {

            e.preventDefault();

            const pin = pinInput.value;

            if (pin.length !== 6) {
                pinInput.focus();
                return;
            }

            stateSelect.value = "";

            if (stateAC) {
                stateAC.refresh();
            }

            citySelect.value = "";
            citySelect.disabled = true;

            resetCity();

            await searchStores({
                pincode: pin
            });
        }
    );

    stateSelect.addEventListener(
        "change",
        async () => {

            const stateId =
                Number(stateSelect.value);

            pinInput.value = "";
            pinBox.classList.remove("ready");
            //citySelect.value = "";

            //citySelect.innerHTML = '';
            //    '<option value="">Select City</option>';
            resetCity();
            if (!stateId) {

                citySelect.disabled = true;
                return;
            }

            await loadCities(stateId);

            //await searchStores({
            //    stateId
            //});
        }
    );

    citySelect.addEventListener(
        "change",
        async () => {

            const stateId =
                Number(stateSelect.value);

            const cityId =
                Number(citySelect.value);

            if (!stateId) {
                return;
            }

            await searchStores({
                stateId,
                cityId: cityId || undefined
            });
        }
    );

    moreBtn.addEventListener(
        "click",
        async () => {

            page++;

            if (lastQuery) {
                await searchStores(
                    lastQuery,
                    true
                );
            }
        }
    );

    document.addEventListener(
        "DOMContentLoaded",
        async () => {

            await loadStates();
        }
    );


})();
